<template>
  <div class="client-permission-page"></div>
</template>

<style scoped>
.client-permission-page {
  min-height: 100%;
}
</style>
